"use client"

import { removeQueryParams } from "@primoui/utils"
import { useTranslations } from "next-intl"
import type { ComponentProps } from "react"
import { Button } from "~/components/legacy/common/button"
import { ArrowUpRightIcon } from "~/components/ui/icons"
import { ExternalLink } from "~/components/web/external-link"
import type { ToolMany, ToolOne } from "~/server/web/tools/payloads"

type ToolButtonProps = ComponentProps<typeof Button> & {
  tool: ToolOne | ToolMany
}

export const ToolButton = ({ children, tool, ...props }: ToolButtonProps) => {
  const t = useTranslations()

  return (
    <Button
      variant={tool.isFeatured ? "fancy" : "primary"}
      suffix={<ArrowUpRightIcon />}
      {...props}
      asChild
    >
      <ExternalLink
        href={tool.affiliateUrl || tool.websiteUrl}
        relPolicy={tool.affiliateUrl ? "sponsored" : "nofollow"}
        doTrack
        toolSlug={tool.slug}
        eventName="marketing.tool_external_clicked"
        plausibleEventName="click_website"
        eventProps={{
          slug: tool.slug,
          target_url: removeQueryParams(tool.affiliateUrl || tool.websiteUrl),
          tool_name: tool.name,
          isFeatured: tool.isFeatured,
          source: "button",
        }}
      >
        {children || t("common.visit", { name: tool.name })}
      </ExternalLink>
    </Button>
  )
}
